import { configureStore } from "@reduxjs/toolkit";
import bannersReducer from "./slices/bannerSlice";
import categoriesReducer from "./slices/categoriesSlice";
import filtersReducer from "./slices/filterSlice";
import companyReducer from "./slices/ProductionCompanySlice";
import productsReducer2 from "./slices/productSlice";
import productsReducer from "./slices/AllProductsSlice";
import newestSlice from "./slices/ProductsNewestSlice";
import offersReducer from "./slices/ProductsOfferSlice";
import ProductDetailsReducer from "./slices/ProductDetailsSlice";
import cartReducer from "./slices/cartSlice";
import checkoutReducer from "./slices/checkoutSlice";
import paymentReducer from "./slices/paymentSlice";
import orderApplyReducer from "./slices/orderApplySlice";
import orderReducer from "./slices/orderSlice";
import commentReducer from './slices/commentSlice';
import benchmarksReducer from './slices/benchmarksSlice';
import contactReducer from './slices/contactSlice';
import { contactUsSlice } from './slices/contactSlice';
import productsBestSellingReducer from './slices/ProductsBestSellingSlice';
import footerSocialLinksReducer from './slices/FooterSocialLinksSlice';
import sliderTextsReducer from './slices/sliderTextsSlice';
import socialLinksReducer from './slices/socialLinksSlice';
import contactUsReducer from './slices/contactUsSlice';
import aboutUsReducer from './slices/aboutUsSlice';
import serviceItemsReducer from './slices/serviceItemsSlice';
import registerReducer from './slices/registerSlice';
import verifyOtpReducer from './slices/verifyOtpSlice';
import sendResetCodeReducer from './slices/sendResetCodeSlice';
import loginReducer from './slices/loginSlice';
import forgetPasswordReducer from './slices/forgetPasswordSlice';
import profileReducer from './slices/profileSlice';
import favoriteReducer from './slices/favoriteSlice';
import pagesReducer from './slices/pagesSlice';

const store = configureStore({
  reducer: {
    banners: bannersReducer,
    categories: categoriesReducer,
    filters: filtersReducer,
    productionCompany: companyReducer,
    products2: productsReducer2,
    products: productsReducer,
    newest: newestSlice,
    offers: offersReducer,
    productDetails: ProductDetailsReducer,
    cart: cartReducer,
    checkout: checkoutReducer,
    payment: paymentReducer,
    orderApply: orderApplyReducer,
    order: orderReducer,
    comments: commentReducer,
    benchmarks: benchmarksReducer,
    contact: contactReducer,
    contactUs: contactUsSlice.reducer,
    productsBestSelling: productsBestSellingReducer,
    footerSocialLinks: footerSocialLinksReducer,
    sliderTexts: sliderTextsReducer,
    socialLinks: socialLinksReducer,
    contactUs: contactUsReducer,
    aboutUs: aboutUsReducer,
    serviceItems: serviceItemsReducer,
    register: registerReducer,
    verifyOtp: verifyOtpReducer,
    sendResetCode: sendResetCodeReducer,
    login: loginReducer,
    forgetPassword: forgetPasswordReducer,
    profile: profileReducer,
    favorite: favoriteReducer,
    pages: pagesReducer,
  },
});
export default store;
